export const getAgencyAssetUrl = (name: string): string => {
  return `${
    import.meta.env.VITE_APP_ASSETS_BUCKET_PATH
  }/agencies/${name}?alt=media`
}

export const getAssetUrl = (name: string): string => {
  const env = import.meta.env.VITE_APP_FIREBASE_PROJECT_ID
  switch (env) {
    case 'tripsapp-dev':
      return `https://firebasestorage.googleapis.com/v0/b/tripsapp-dev-cdn/o/assets%2F${name}?alt=media`
    case 'tripsapp-uat':
      return `https://firebasestorage.googleapis.com/v0/b/tripsapp-uat-cdn/o/${name}?alt=media`
    case 'tripsapp-prod':
      return `https://firebasestorage.googleapis.com/v0/b/tripsapp-prod-cdn/o/${name}?alt=media`
    default:
      return `https://firebasestorage.googleapis.com/v0/b/tripsapp-dev-cdn/o/assets%2F${name}?alt=media`
  }
}
